module.exports = "/images/ny-life1-5.jpg";